<template>
  <div class="pagina-login">
    <div class="tarjeta-login">
      <!-- Panel de marca: solo en pantalla grande, en celular estorba -->
      <div class="panel-marca">
        <img
          :src="require('@/assets/img-vendiendo1.jpg')"
          alt=""
          class="fondo-marca"
        >
        <div class="capa-marca">
          <div class="claim">Tu negocio, visible</div>
          <p class="claim-texto">
            Publica tu empresa, muestra tus productos y deja que te encuentren.
          </p>
        </div>
      </div>

      <!-- Formulario -->
      <div class="panel-formulario">
        <img
          :src="require('@/assets/logo.png')"
          alt="Bahiol"
          class="logo"
        >

        <h1 class="titulo">Iniciar sesión</h1>
        <p class="subtitulo">Entra para administrar tu empresa</p>

        <v-form @submit.prevent="login">
          <v-text-field
            v-model="usuario"
            class="fg-blue mb-2"
            label="Usuario o correo"
            variant="outlined"
            density="comfortable"
            autocomplete="username"
            :autofocus="!usuario"
            prepend-inner-icon="mdi-account-outline"
            :error="!!error"
            hide-details="auto"
          />

          <v-text-field
            v-model="clave"
            class="fg-blue mb-2"
            label="Contraseña"
            variant="outlined"
            density="comfortable"
            autocomplete="current-password"
            :autofocus="!!usuario"
            prepend-inner-icon="mdi-lock-outline"
            :type="verClave ? 'text' : 'password'"
            :append-inner-icon="verClave ? 'mdi-eye-off' : 'mdi-eye'"
            :error="!!error"
            hide-details="auto"
            @click:append-inner="verClave = !verClave"
          />

          <v-alert
            v-if="error"
            type="error"
            variant="tonal"
            density="compact"
            class="mt-3"
          >
            {{ error }}
          </v-alert>

          <v-btn
            type="submit"
            color="primary"
            size="large"
            block
            class="mt-4"
            :loading="entrando"
          >
            Entrar
          </v-btn>
        </v-form>

        <div class="olvide">
          <a
            class="enlace"
            @click="$router.push({ name: 'RecuperarClaveView' })"
          >¿Olvidaste tu contraseña?</a>
        </div>

        <div class="pie">
          ¿No tienes cuenta?
          <a
            class="enlace"
            @click="$router.push({ name: 'RegistreView' })"
          >Regístrate</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apisUser from '@/apis/apisUsers'

export default {
  name: 'LoginView',
  data() {
    return {
      usuario: '',
      clave: '',
      verClave: false,
      entrando: false,
      error: ''
    }
  },
  created() {
    // Al volver de recuperar la clave, el correo llega en la query para no
    // obligar a escribirlo otra vez. El foco queda en la clave, que es lo
    // unico que falta
    const correo = this.$route.query.correo

    if (correo) {
      this.usuario = String(correo)
    }
  },
  methods: {
    login() {
      this.error = ''

      // Se valida aqui para no gastar un viaje al servidor con campos vacios
      if (!this.usuario.trim() || !this.clave) {
        this.error = 'Escribe tu usuario o correo y tu contraseña'
        return
      }

      this.entrando = true

      apisUser.login(this.usuario.trim(), this.clave)
        .then(entro => {
          if (entro) {
            // Navegacion del router y no window.location: recargar el SPA
            // entero despues de entrar cuesta varios segundos en conexiones
            // lentas. El encabezado se actualiza solo, App.vue revisa la
            // sesion cada 3 segundos.
            this.$router.push('/')
          } else {
            this.error = 'Usuario, correo o contraseña incorrectos'
          }
        })
        .catch(() => {
          // Antes no habia catch: si el servidor no respondia, el boton se
          // quedaba girando para siempre y el usuario no sabia que pasaba
          this.error = 'No pudimos conectar con el servidor. Intenta de nuevo.'
        })
        .finally(() => {
          this.entrando = false
        })
    }
  }
}
</script>

<style scoped>
.pagina-login {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 140px);
  padding: 16px;
  background: linear-gradient(160deg, #dbeafe 0%, #eff6ff 45%, #f8fafc 100%);
}

.tarjeta-login {
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  max-width: 420px;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(25, 118, 210, 0.12);
}

/* El panel de marca no existe en celular: ahi lo que importa es entrar */
.panel-marca {
  display: none;
}

.panel-formulario {
  padding: 28px 24px 24px;
}

.logo {
  height: 44px;
  display: block;
  margin: 0 auto 14px;
}

.titulo {
  font-size: 1.35rem;
  font-weight: 700;
  color: #111;
  text-align: center;
  margin: 0;
}

.subtitulo {
  font-size: 0.85rem;
  color: #777;
  text-align: center;
  margin: 4px 0 20px;
}

.olvide {
  margin-top: 12px;
  text-align: center;
  font-size: 0.85rem;
}

.pie {
  margin-top: 10px;
  text-align: center;
  font-size: 0.85rem;
  color: #666;
}

.enlace {
  color: #1976d2;
  font-weight: 600;
  cursor: pointer;
  margin-left: 2px;
}
.enlace:hover {
  text-decoration: underline;
}

@media (min-width: 900px) {
  .tarjeta-login {
    grid-template-columns: 1fr 1fr;
    max-width: 860px;
  }

  .panel-marca {
    display: block;
    position: relative;
    min-height: 100%;
  }
  .fondo-marca {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .capa-marca {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 28px;
    color: #fff;
    background: linear-gradient(
      to top,
      rgba(13, 47, 89, 0.88) 0%,
      rgba(13, 47, 89, 0.45) 55%,
      rgba(13, 47, 89, 0.15) 100%
    );
  }
  .claim {
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1.2;
  }
  .claim-texto {
    font-size: 0.9rem;
    line-height: 1.45;
    margin: 8px 0 0;
    opacity: 0.92;
  }

  .panel-formulario {
    padding: 40px 36px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
